import React from 'react';
import { cn } from '../../lib/utils';

const DataTable = ({ columns, rows, isFullScreen = false, compact = false }) => {
  // Normalize columns to objects if they are strings
  const normalizedColumns = columns.map(col =>
    typeof col === 'string' ? { key: col, label: col } : col
  );

  return (
    <div className="w-full h-full overflow-auto custom-scrollbar">
      <table className="w-full text-left border-collapse table-auto">
        <thead
          className={cn(
            'sticky top-0 z-10',
            compact
              ? 'bg-gray-50/50 dark:bg-gray-900/20'
              : 'bg-white dark:bg-gray-950 transition-colors shadow-[0_1px_0_0_rgba(0,0,0,0.05)] dark:shadow-[0_1px_0_0_rgba(255,255,255,0.05)]'
          )}
        >
          <tr className={compact ? 'border-b border-gray-100 dark:border-gray-900' : undefined}>
            {normalizedColumns.map(col => (
              <th
                key={col.key}
                className={cn(
                  'font-black text-gray-400 uppercase whitespace-nowrap text-left',
                  compact
                    ? 'text-[9px] tracking-wider py-2 px-3'
                    : 'pb-3 pt-2 px-4 tracking-widest border-b border-gray-100 dark:border-gray-800',
                  !compact && isFullScreen ? 'text-xs pt-5 pb-4 px-8' : !compact ? 'text-[11px]' : null
                )}
              >
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-50 dark:divide-gray-900/50">
          {rows.map((row, i) => (
            <tr
              key={i}
              className={cn(
                'transition-colors group',
                compact
                  ? 'hover:bg-gray-50/50 dark:hover:bg-gray-900/30'
                  : 'hover:bg-emerald-50/20 dark:hover:bg-emerald-900/5'
              )}
            >
              {normalizedColumns.map((col, j) => {
                const cellValue = Array.isArray(row) ? row[j] : row[col.key];
                return (
                  <td
                    key={j}
                    className={cn(
                      'font-medium text-gray-700 dark:text-gray-200 whitespace-nowrap',
                      compact
                        ? 'py-2 px-3 text-[11px]'
                        : 'border-r border-transparent group-hover:border-emerald-50 dark:group-hover:border-emerald-900/20 last:border-r-0',
                      !compact && isFullScreen ? 'py-5 px-8 text-sm' : !compact ? 'py-2.5 px-4 text-xs' : null
                    )}
                  >
                    {typeof cellValue === 'object' && cellValue !== null ? JSON.stringify(cellValue) : String(cellValue ?? '')}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DataTable;
